var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1795 6H12.8205C9.05846 6 6 9.05846 6 12.8205V27.1795C6 30.9415 9.05846 34 12.8205 34H27.1795C30.9415 34 34 30.9415 34 27.1795V12.8205C34 9.05846 30.9415 6 27.1795 6ZM12.8205 8.15385H27.1795C29.7497 8.15385 31.8462 10.2503 31.8462 12.8205V22.1538L28.6872 19.7846C27.7969 19.1241 26.5621 19.1241 25.6718 19.7846L21.2636 23.0872L17.5733 19.0236C17.0995 18.4923 16.4246 18.2051 15.7067 18.2051H15.6779C14.96 18.2051 14.2851 18.521 13.8113 19.0667L8.13949 25.5426V12.8205C8.13949 10.2503 10.2359 8.15385 12.8062 8.15385H12.8205ZM8.38359 28.5579L15.4482 20.4882C15.5344 20.3877 15.6492 20.3733 15.721 20.3733C15.7641 20.3446 15.8933 20.3733 15.9938 20.4882L26.3323 31.8605H12.8205C10.7241 31.8605 8.97231 30.4677 8.38359 28.5723V28.5579ZM28.9169 31.5159L22.7282 24.7097L26.9785 21.5221C27.1077 21.4215 27.28 21.4215 27.4092 21.5221L31.8605 24.8533V27.1938C31.8605 29.161 30.64 30.8267 28.9313 31.5159H28.9169Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5897 16.7692C25.3702 16.7692 26.8204 15.3189 26.8204 13.5384C26.8204 11.7579 25.3702 10.3076 23.5897 10.3076C21.8091 10.3076 20.3589 11.7579 20.3589 13.5384C20.3589 15.3189 21.8091 16.7692 23.5897 16.7692ZM23.5897 12.4615C24.1784 12.4615 24.6666 12.9497 24.6666 13.5384C24.6666 14.1271 24.1784 14.6153 23.5897 14.6153C23.0009 14.6153 22.5127 14.1271 22.5127 13.5384C22.5127 12.9497 23.0009 12.4615 23.5897 12.4615Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedias);
export default __webpack_public_path__ + "static/media/medias.5d29ff16.svg";
export { ForwardRef as ReactComponent };